import { createFileRoute } from '@tanstack/react-router';

import {
  AdminPageHeader,
  BreadcrumbItemProps,
} from '@/features/admin/components/AdminPageHeader';
import { UserDetails } from '@/features/manage-users/components/UserDetails';
import { getAgentsQueryOptions } from '@/features/manage-users/queries/getAgents';
import {
  getUserQueryOptions,
  useGetUser,
} from '@/features/manage-users/queries/getUser';
import { AppPageContent } from '@/features/shared/components/AppPageContent';
import { UserRoles } from '@/lib/constants/auth.constants.ts';
import { requireRole } from '@/lib/validation';

export const Route = createFileRoute(
  '/_app/app/admin-section/users/$sourcedId'
)({
  component: RouteComponent,
  beforeLoad: requireRole([UserRoles.ADMINISTRATOR]),
  loaderDeps: ({ search }) => ({
    search,
  }),
  loader: async ({ context, params }) => {
    if (!params.sourcedId) {
      return;
    }

    await context.queryClient.prefetchQuery(
      getUserQueryOptions(params.sourcedId)
    );

    await context.queryClient.prefetchQuery(
      getAgentsQueryOptions(params.sourcedId)
    );
  },
  ssr: false,
});

function RouteComponent() {
  const { sourcedId } = Route.useParams();

  const { data: user } = useGetUser(sourcedId);

  let userFullName = '';
  if (user?.givenName && user?.familyName) {
    userFullName = `${user.givenName} ${user.familyName}`;
  }

  const breadcrumbItems: BreadcrumbItemProps[] = [
    {
      label: 'Home',
      link: { to: '/app' },
    },
    {
      label: 'Administration',
      link: { to: '/app' },
    },
    {
      label: 'Users',
      link: { to: '/app/admin-section/users' },
    },
    {
      label: userFullName || 'User Details',
      link: {
        to: '/app/admin-section/users/$sourcedId',
        params: { sourcedId },
      },
    },
  ];

  return (
    <AppPageContent className="overflow-hidden">
      <AdminPageHeader breadcrumbItems={breadcrumbItems} />
      <UserDetails />
    </AppPageContent>
  );
}
